import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../locales/translations';
import { SurveyComponent } from '../../../../models/SurveyTemplates';


interface PhoneInputFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.SURVEY_BUILDER]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Allow only numbers, spaces, hyphens, parentheses, and plus sign
        const cleanedValue = e.target.value.replace(/[^0-9\s\-\(\)\+]/g, '');
        onChange?.(cleanedValue);
    };

    const validatePhone = (phone: string) => {
        // Basic phone validation - at least 10 digits
        const digitsOnly = phone.replace(/\D/g, '');
        return digitsOnly.length >= 10;
    };

    const isValid = !value || validatePhone(value);

    return (
        <TextField
            type="tel"
            value={value}
            onChange={handleChange}
            disabled={disabled}
            fullWidth
            variant="outlined"
            size="small"
            placeholder={field.placeholder || t('field_messages.phone_input.placeholder') as string}
            error={!isValid}
            helperText={!isValid ? t('field_messages.phone_input.validation_error') : undefined}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <PhoneIcon color={isValid ? 'inherit' : 'error'} />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default PhoneInputField;
